module.exports = __webpack_public_path__ + "img/flag-usa.c6f63129.svg";